import { motion } from 'framer-motion'
import AtomBackground from './Atombackground'
import Reveal from './Reveal'
import videoSrc from '../assets/Videopresentacion.mp4'
import fotoSrc from '../assets/imagen.png'

const milestones = [
  {
    year: '2016',
    title: 'Inicio de actividad docente',
    text: 'Desarrollo de una metodología centrada en comprensión real y razonamiento.',
  },
  {
    year: '2019',
    title: 'Fundación de IDM Medicina en Mar del Plata',
    text: 'Nacimiento de una comunidad enfocada en transformar la manera de aprender medicina.',
  },
  {
    year: '2021',
    title: 'Lanzamiento de los primeros cursos online',
    text: 'Más de 1.000 alumnos formados durante el primer año digital.',
  },
  {
    year: '2026',
    title: 'Comunidad consolidada a nivel internacional',
    text: '210k+ seguidores, millones de reproducciones y 6 programas activos ayudando estudiantes de medicina en todo el mundo.',
  },
]

function MoleculeDecor() {
  return (
    <svg
      width="140" height="140" viewBox="0 0 120 120"
      className="absolute -top-6 -right-6 opacity-[0.06] pointer-events-none"
      fill="none"
    >
      <circle cx="60" cy="60" r="40" stroke="#C9A84C" strokeWidth="1"/>
      <circle cx="60" cy="60" r="25" stroke="#C9A84C" strokeWidth="0.5"/>
      <circle cx="60" cy="20" r="6" fill="#C9A84C"/>
      <circle cx="60" cy="100" r="6" fill="#C9A84C"/>
      <circle cx="20" cy="60" r="6" fill="#C9A84C"/>
      <circle cx="100" cy="60" r="6" fill="#C9A84C"/>
      <line x1="60" y1="20" x2="60" y2="100" stroke="#C9A84C" strokeWidth="0.5"/>
      <line x1="20" y1="60" x2="100" y2="60" stroke="#C9A84C" strokeWidth="0.5"/>
    </svg>
  )
}

/* ── panel decorativo izquierdo junto al timeline (solo desktop) ── */
function TimelineDecorPanel() {
  return (
    <motion.div
      className="hidden lg:flex flex-col justify-center items-center gap-0 h-full"
      initial={{ opacity: 0, x: -16 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="relative flex items-center justify-center" style={{ width: 220, height: 220 }}>
        <svg
          viewBox="0 0 200 200"
          width="220" height="220"
          fill="none"
          style={{ opacity: 0.1, position: 'absolute' }}
        >
          <circle cx="100" cy="100" r="80" stroke="#C9A84C" strokeWidth="1"/>
          <circle cx="100" cy="100" r="55" stroke="#C9A84C" strokeWidth="0.6"/>
          <circle cx="100" cy="100" r="30" stroke="#C9A84C" strokeWidth="0.4"/>
          <line x1="100" y1="20" x2="100" y2="180" stroke="#C9A84C" strokeWidth="0.5"/>
          <line x1="20" y1="100" x2="180" y2="100" stroke="#C9A84C" strokeWidth="0.5"/>
          <line x1="43" y1="43" x2="157" y2="157" stroke="#C9A84C" strokeWidth="0.4"/>
          <line x1="157" y1="43" x2="43" y2="157" stroke="#C9A84C" strokeWidth="0.4"/>
          <circle cx="100" cy="20" r="5" fill="#C9A84C"/>
          <circle cx="100" cy="180" r="5" fill="#C9A84C"/>
          <circle cx="20" cy="100" r="5" fill="#C9A84C"/>
          <circle cx="180" cy="100" r="5" fill="#C9A84C"/>
          <circle cx="43" cy="43" r="3.5" fill="#C9A84C"/>
          <circle cx="157" cy="43" r="3.5" fill="#C9A84C"/>
          <circle cx="43" cy="157" r="3.5" fill="#C9A84C"/>
          <circle cx="157" cy="157" r="3.5" fill="#C9A84C"/>
          <circle cx="100" cy="100" r="8" fill="#C9A84C"/>
        </svg>
        <div className="relative z-10 flex flex-col items-center gap-1 text-center">
          <span
            className="font-display font-black"
            style={{ fontSize: 10, letterSpacing: '0.2em', color: 'var(--gold)', opacity: 0.6, textTransform: 'uppercase' }}
          >
            Trayectoria
          </span>
          <span
            className="font-display font-black"
            style={{ fontSize: 36, color: 'var(--gold)', lineHeight: 1 }}
          >
            10+
          </span>
          <span
            className="font-body font-light"
            style={{ fontSize: 11, color: 'var(--ink-3)', letterSpacing: '0.06em' }}
          >
            años enseñando
          </span>
        </div>
      </div>
      <motion.p
        className="font-body font-light italic text-center"
        style={{ fontSize: 11, color: 'var(--ink-3)', lineHeight: 1.75, letterSpacing: '0.02em', maxWidth: 200, marginTop: 16 }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.5, duration: 0.6 }}
      >
        "Cada año, más estudiantes comprenden medicina de una manera diferente."
      </motion.p>
    </motion.div>
  )
}

/* ── video compatible con iOS y Android ────────── */
function VideoBlock({ title, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-col gap-3"
    >
      {title && (
        <span
          className="font-display font-black text-[11px] tracking-[0.14em] uppercase"
          style={{ color: 'var(--gold)', opacity: 0.85 }}
        >
          {title}
        </span>
      )}

      {/*
        Truco cross-browser para mantener 16/9:
        position relative + paddingBottom 56.25% + height 0
        El video queda absolute fill adentro.
        Esto funciona en Safari iOS, Chrome Android y todos los demás.
      */}
      <div
        style={{
          position: 'relative',
          width: '100%',
          paddingBottom: '56.25%', /* 16:9 */
          height: 0,
          overflow: 'hidden',
          background: '#000',
          border: '1px solid var(--line)',
        }}
      >
        <video
          src={videoSrc}
          controls
          playsInline                  /* iOS: reproduce inline, no fullscreen forzado */
          webkit-playsinline="true"    /* Safari iOS legacy */
          preload="metadata"           /* carga el primer frame como thumbnail */
          controlsList="nodownload"    /* oculta botón de descarga en Chrome */
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'block',
            /* NO objectFit cover: en algunos Android distorsiona los controles */
          }}
        >
          {/*
            Si el navegador no soporta el tipo, muestra este fallback.
            Podés agregar un <source type="video/webm"> si tenés esa versión.
          */}
          <source src={videoSrc} type="video/mp4" />
          Tu navegador no soporta reproducción de video.
        </video>
      </div>
    </motion.div>
  )
}

/* ── timeline item ──────────────────────────────── */
function TimelineItem({ year, title, text, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -14 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.07 * i, duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
      className="relative flex gap-5 sm:gap-7 py-5"
    >
      <motion.div
        className="absolute -left-[25px] top-[26px] w-2 h-2 rounded-full"
        style={{ background: 'var(--gold)' }}
        initial={{ scale: 0 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.07 * i + 0.2, duration: 0.35, type: 'spring', stiffness: 400 }}
      />
      <span
        className="font-display font-black shrink-0 pt-0.5"
        style={{ fontSize: 'clamp(12px,2vw,14px)', color: 'var(--gold)', minWidth: '38px' }}
      >
        {year}
      </span>
      <div className="flex flex-col gap-1">
        <span
          className="font-display font-black"
          style={{ fontSize: 'clamp(12px,2vw,13px)', color: 'var(--ink)', lineHeight: 1.3 }}
        >
          {title}
        </span>
        <span
          className="font-body font-light leading-[1.65]"
          style={{ fontSize: 'clamp(12px,1.8vw,13px)', color: 'var(--ink-2)' }}
        >
          {text}
        </span>
      </div>
    </motion.div>
  )
}

/* ── section label ──────────────────────────────── */
function SectionLabel({ children }) {
  return (
    <div className="flex items-center gap-3 mb-4">
      <span style={{ display: 'inline-block', width: 20, height: 1, background: 'var(--gold)', opacity: 0.7 }}/>
      <span
        className="font-display font-semibold uppercase tracking-[0.18em]"
        style={{ fontSize: 10, color: 'var(--gold)', opacity: 0.85 }}
      >
        {children}
      </span>
    </div>
  )
}

/* ── main component ─────────────────────────────── */
export default function SobreMi() {
  return (
    <section
      id="sobre"
      className="relative overflow-hidden"
      style={{ padding: 'clamp(72px,10vw,120px) clamp(20px,5vw,6vw)', background: 'var(--bg)' }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ width: '100%', height: '100%' }}
      >
        <AtomBackground />
      </div>

      <div
        aria-hidden
        className="absolute pointer-events-none"
        style={{
          left: '20%', top: '30%',
          width: 'min(60vw, 500px)', height: 'min(60vw, 500px)',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(201,168,76,0.05) 0%, transparent 65%)',
          filter: 'blur(80px)',
        }}
      />

      <div className="relative z-10">

        {/* ── HEADER ── */}
        <Reveal>
          <SectionLabel>Sobre mí</SectionLabel>
          <h2
            className="font-display font-black leading-[1.04] tracking-[-0.02em] mb-0"
            style={{ fontSize: 'clamp(1.8rem, 4vw, 3.2rem)', color: 'var(--ink)', maxWidth: 680 }}
          >
            Una trayectoria al servicio<br />
            de{' '}
            <em className="not-italic" style={{ color: 'var(--gold)' }}>tu aprendizaje</em>.
          </h2>
        </Reveal>

        {/* ── MAIN GRID ── */}
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-12 lg:gap-16 mt-14 lg:mt-16 items-start">

          {/* LEFT: foto */}
          <Reveal delay={0.1}>
            <div className="relative">
              <div
                className="absolute -top-4 -right-4 w-14 h-14 pointer-events-none"
                style={{ borderTop: '2px solid var(--gold)', borderRight: '2px solid var(--gold)' }}
              />
              <div
                className="absolute -bottom-4 -left-4 w-14 h-14 pointer-events-none"
                style={{ borderBottom: '2px solid var(--gold)', borderLeft: '2px solid var(--gold)' }}
              />
              <MoleculeDecor />

              <motion.div
                className="w-full relative overflow-hidden"
                style={{ aspectRatio: '3/4', border: '1px solid var(--line)' }}
                whileHover={{ borderColor: 'rgba(201,168,76,0.35)' }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src={fotoSrc}
                  alt="Foto profesional"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center top',
                    display: 'block',
                  }}
                />
              </motion.div>

              <motion.div
                className="absolute bottom-8 -left-5 font-display font-black tracking-[0.1em] uppercase px-5 py-2.5"
                style={{ background: 'var(--gold)', color: '#000', fontSize: 10 }}
                initial={{ x: -8, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3, duration: 0.55, ease: [0.22,1,0.36,1] }}
              >
                Mentor
              </motion.div>
            </div>
          </Reveal>

          {/* RIGHT: copy + video */}
          <Reveal delay={0.2}>
            <div className="flex flex-col gap-6">

              <div className="flex flex-col gap-4">
                <p
                  className="font-body font-light leading-[1.9]"
                  style={{ fontSize: 'clamp(13px,1.8vw,15px)', color: 'var(--ink-2)' }}
                >
                  Educador especializado en medicina, con más de 10 años de experiencia docente.
                  No creo en memorizar 400 diapositivas sin comprender realmente qué estás viendo.
                </p>
                <p
                  className="font-body font-light leading-[1.9]"
                  style={{ fontSize: 'clamp(13px,1.8vw,15px)', color: 'var(--ink-2)' }}
                >
                  Durante años vi estudiantes sentirse incapaces, cuando el problema no era su
                  inteligencia, sino la manera en que se les enseñaba medicina.
                  Por eso construí una metodología basada en claridad, razonamiento y comprensión real.
                </p>
                <p
                  className="font-body font-light leading-[1.9]"
                  style={{ fontSize: 'clamp(13px,1.8vw,15px)', color: 'var(--ink-2)' }}
                >
                  Mi enfoque parte de explicar los temas desde una lógica simple, utilizando ejemplos
                  cotidianos y razonamientos fáciles de visualizar. Una vez entendido el concepto,
                  avanzamos progresivamente hacia el funcionamiento preciso y profundo de cada mecanismo.
                  Todo está orientado al entendimiento, no a la memoria por sí sola.
                </p>

                <motion.div
                  className="flex gap-4 mt-1"
                  initial={{ opacity: 0, x: -8 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.25, ease: [0.22,1,0.36,1] }}
                >
                  <div style={{ width: 2, background: 'var(--gold)', opacity: 0.4, flexShrink: 0, borderRadius: 2 }}/>
                  <p
                    className="font-body font-light leading-[1.85] italic"
                    style={{ fontSize: 'clamp(13px,1.8vw,14px)', color: 'var(--ink-2)' }}
                  >
                    Mi obsesión es desarmar procesos complejos y transformarlos en explicaciones que
                    cualquier persona pueda comprender, incluso sin venir del mundo médico.
                  </p>
                </motion.div>
              </div>

              <motion.div
                style={{ height: 1, background: 'linear-gradient(90deg, var(--gold) 0%, transparent 100%)', opacity: 0.15 }}
                initial={{ scaleX: 0, originX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1, ease: [0.22,1,0.36,1] }}
              />

              <VideoBlock title="Conocé cómo enseño medicina" delay={0.15} />

            </div>
          </Reveal>
        </div>

        {/* ── TIMELINE SECTION ── */}
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_3fr] gap-12 lg:gap-16 mt-8 lg:mt-10 items-start">

          <TimelineDecorPanel />

          <Reveal delay={0.1}>
            <motion.div
              style={{ height: 1, background: 'linear-gradient(90deg, var(--gold) 0%, transparent 100%)', opacity: 0.15, marginBottom: 24 }}
              initial={{ scaleX: 0, originX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.1, ease: [0.22,1,0.36,1] }}
            />
            <div
              className="flex flex-col pl-7"
              style={{ borderLeft: '1px solid var(--line)' }}
            >
              {milestones.map((m, i) => (
                <TimelineItem key={m.year} {...m} i={i} />
              ))}
            </div>
          </Reveal>
        </div>

      </div>
    </section>
  )
}